import { render, staticRenderFns } from "./VisitaPreviaTab.vue?vue&type=template&id=68f805ce&"
import script from "./VisitaPreviaTab.vue?vue&type=script&lang=js&"
export * from "./VisitaPreviaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports